// extracted by mini-css-extract-plugin
export var wrapper = "hero-module--wrapper--hqudj";
export var column = "hero-module--column--2Va4U";
export var title = "hero-module--title--6QmM5";
export var description = "hero-module--description--fgyWK";
export var button = "hero-module--button--1cbKi";
export var extra = "hero-module--extra--6bHgt";